import { match } from 'ts-pattern';
import { Model } from '../index.js';
export const migrateToV6 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().when((e)=>Model.GrillBase.isId(e.id), (e)=>({
                ...e,
                warmingDrawerId: null
            })).when((e)=>Model.LynxGrill.isId(e.id), (e)=>({
                ...e,
                powderCoating: false
            })).when((e)=>Model.LynxAsadoGriddgle.isId(e.id), (e)=>({
                ...e,
                powderCoating: false
            })).when((e)=>Model.LynxBurner.isId(e.id), (e)=>({
                ...e,
                powderCoating: false
            })).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v06.js.map